import { render } from "./group_feed_comment.html?vue&type=template&id=38e5545c&external"
import script from "./group_feed_comment.js?vue&type=script&lang=js&external"
export * from "./group_feed_comment.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__